import { render } from "./App.vue?vue&type=template&id=74ecf2d4"
const script = {}

import "./App.vue?vue&type=style&index=0&id=74ecf2d4&lang=scss"
script.render = render

export default script